import type { Role, TenantContextDto } from "@madamuh/domain";
import { apiGet, apiPost } from "./client";

export type SupportCategoryOption = { value: string; label: string };
export type SupportContext = {
  tenant: TenantContextDto;
  roles: Role[];
  isTenantOwner: boolean;
  categories: SupportCategoryOption[];
};

export type SubmitSupportTicketRequest = {
  requestId: string;
  category: string;
  name: string;
  replyEmail: string;
  message: string;
};

export type SubmitSupportTicketResponse = {
  ticketId: string;
  duplicate: boolean;
  status: "queued";
  message: string;
};

export async function fetchSupportContext(tenantSlug: string): Promise<SupportContext> {
  return await apiGet<SupportContext>(`/api/v1/app/tenants/${tenantSlug}/support-context`);
}

export async function submitSupportTicket(
  tenantSlug: string,
  request: SubmitSupportTicketRequest
): Promise<SubmitSupportTicketResponse> {
  return await apiPost<SubmitSupportTicketRequest, SubmitSupportTicketResponse>(
    `/api/v1/app/tenants/${tenantSlug}/support-tickets`,
    request
  );
}
